// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2F066","logo":"Header_logo__7ZNde","profile":"Header_profile__25tw7","menu":"Header_menu__1gvUz","iconMenu":"Header_iconMenu__1xgqc"};